import { render, staticRenderFns } from "./BuilderItemParent.vue?vue&type=template&id=357f33f8&scoped=true&"
import script from "./BuilderItemParent.vue?vue&type=script&lang=js&"
export * from "./BuilderItemParent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357f33f8",
  null
  
)

export default component.exports